import React, { useContext } from "react";
import { DataContext } from "../../Context/Context";
import { Bar } from "react-chartjs-2";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 15,
    textAlign: "left",
    margin: 0,
    color: "grey",
    fontWeight: 600,
    padding: "10px 10px",
    backgroundColor: "rgb(240, 238, 238)",
  },
  chart: {
    padding: 10,
  },
}));

export default function IncomeChart() {
  const classes = useStyles();
  const { expense, wizardCategories } = useContext(DataContext);

  const data = {
    labels: expense.map((e) => {
      let cat = wizardCategories.filter((cat) => e.id == cat.id);
      return cat[0].name;
    }),
    datasets: [
      {
        label: "Amount",
        data: expense.map((e) => {
          return e.amount;
        }),
        backgroundColor: ["#b30a2e"],
        borderColor: ["#b30a2e"],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: "y",

    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
      },
    },
  };

  return (
    <>
      <Paper elevation={3}>
        <h1 className={classes.title}>Expenses</h1>
        <div className={classes.chart}>
          <Bar data={data} options={options} />
        </div>
      </Paper>
    </>
  );
}
